const calendarFormat = {
  sameDay: '[Today]',
  nextDay: '[Tomorrow]',
  nextWeek: '[this] dddd',
  lastDay: '[Yesterday]',
  lastWeek: '[on] dddd',
  sameElse: '[on] MMM Do',
};

export default calendarFormat;
